import React from "react";
import {
  Stack,
  Box,
  InputLabel,
  ToggleButtonGroup,
  ToggleButton,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import {
  CalendarToday,
  Today as TodayIcon,
  Clear as ClearIcon,
  Keyboard as KeyboardIcon,
} from "@mui/icons-material";
import moment from "moment";
import CalendarDateRangePicker from "components/Time/CalendarDateRangePicker/CalendarDateRangePicker";

const InvoiceDateRangePicker = ({
  invoice,
  displayDates,
  datePickerView,
  onDatePickerViewChange,
  onCalendarDateChange,
  onDateFieldChange,
  onTodayClick,
  onClearClick,
}) => {
  return (
    <Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        spacing={1}
        sx={{ mb: 2 }}
      >
        <ToggleButtonGroup
          value={datePickerView}
          exclusive
          onChange={onDatePickerViewChange}
          sx={{ m: 0, p: 0 }}
        >
          <ToggleButton value="inputs" aria-label="input view">
            <KeyboardIcon />
          </ToggleButton>
          <ToggleButton value="calendar" aria-label="calendar view">
            <CalendarToday />
          </ToggleButton>
        </ToggleButtonGroup>

        <Stack direction="row" spacing={1}>
          <Button
            startIcon={<TodayIcon />}
            onClick={
              datePickerView === "calendar"
                ? () => onCalendarDateChange([new Date(), null])
                : onTodayClick
            }
            variant="outlined"
          >
            Today
          </Button>

          <Button
            startIcon={<ClearIcon />}
            onClick={
              datePickerView === "calendar"
                ? () => onCalendarDateChange([null, null])
                : onClearClick
            }
            variant="outlined"
            disabled={
              datePickerView === "calendar"
                ? !invoice.from_date && !invoice.to_date
                : !displayDates.from_date && !displayDates.to_date
            }
          >
            Clear
          </Button>
        </Stack>
      </Stack>
      {datePickerView === "inputs" && (
        <Stack direction="row" spacing={2} justifyContent="space-between">
          <Box sx={{ width: "48%" }}>
            <InputLabel>Start Date for this Engagement

            </InputLabel>
            <TextField
              type="date"
              value={displayDates.from_date || ""}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              name="from_date"
              onChange={onDateFieldChange}
              required
            />
          </Box>
          <Box sx={{ width: "48%" }}>
            <InputLabel>End Date for this Engagement</InputLabel>
            <TextField
              type="date"
              value={displayDates.to_date || ""}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              name="to_date"
              onChange={onDateFieldChange}
              required
            />
          </Box>
        </Stack>
      )}
      {datePickerView === "calendar" && (
        <>
          <CalendarDateRangePicker
            calendars={1}
            value={[
              invoice.from_date
                ? moment(invoice.from_date, "YYYY-MM-DD").toDate()
                : null,
              invoice.to_date
                ? moment(invoice.to_date, "YYYY-MM-DD").toDate()
                : null,
            ]}
            onChange={(value) => {
              onCalendarDateChange(value);
            }}
          />
        </>
      )}
    </Stack>
  );
};

export default InvoiceDateRangePicker;
